import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import '../../pages/Players/Players.css'

class PlayersTable extends Component {

  state = {
    data: [{}],
    redirectToPayment: false
  };

 

  componentDidMount() {
    fetch(`https://e4x1efau0g.execute-api.us-east-1.amazonaws.com/pramukhcup/listPlayer`)
      .then(results => {
        return results.json();
      }).then(resp => {
        this.setState({ 
          data: resp
        });
      });
  }

  render() {
    const { data } = this.state;
    const options = {
      sizePerPage: 20,
      prePage: 'Previous',
      nextPage: 'Next',
      firstPage: 'First',
      lastPage: 'Last',
      hideSizePerPage: true,
    };

    return (
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="header">
                <h4>Players</h4>
              </div>
              <div>
                <Grid>                    
                    <Row>
                        <Col xs={9} md={6}>                        
                            <ul class="list-inline">
                                <li>Total<br/> <span >{this.state.data.length}</span></li>
                                <li>{this.state.redirectToPayment?'Registered':'Play'}<br/> <span >{this.state.redirectToPayment?this.state.data.filter(data => data.status === 'Registered').length:this.state.data.filter(data => data.playerType === 'I will play').length}</span></li>                                                                
                            </ul>
                        </Col>
                        <Col xs={9} md={6}>
                        </Col>
                    </Row>
                </Grid>
              </div>
              <div className="content">
                <BootstrapTable
                  data={data}
                  bordered={false}
                  striped
                  pagination={true}
                  options={options}>
                  <TableHeaderColumn
                    dataField='firstName'
                    isKey
                    width="15%"
                    filter={ { type: 'TextFilter'} }
                    dataSort>
                    First Name
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField='lastName'
                    width="15%"
                    filter={ { type: 'TextFilter'} }
                    dataSort>
                    Last Name
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField='zoneName'
                    width="20%"
                    filter={ { type: 'TextFilter'} }
                    dataSort>
                    {this.state.redirectToPayment? 'Zone':'Department'}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField='playerType'
                    width="15%"
                    filter={ { type: 'TextFilter'} }
                    hidden={this.state.redirectToPayment}
                    dataSort>
                    Participant Type
                  </TableHeaderColumn> 
                  <TableHeaderColumn
                    dataField='status'
                    width="15%"
                    filter={ { type: 'TextFilter'} }
                    hidden={!this.state.redirectToPayment}
                    dataSort>
                    Status
                  </TableHeaderColumn>  
                  <TableHeaderColumn
                    dataField='tshirtSize'
                    width="10%"
                    filter={ { type: 'TextFilter'} }
                    hidden={!this.state.redirectToPayment}
                    dataSort>
                    T-Shirt Size
                  </TableHeaderColumn>   
                  <TableHeaderColumn
                    dataField='createTime'
                    width="20%"
                    filter={ { type: 'TextFilter'} }
                    dataSort>
                    Registration Time
                  </TableHeaderColumn>                  
                  <TableHeaderColumn width="20%"></TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
export default PlayersTable


// WEBPACK FOOTER //
// ./src/components/Table/PlayersTable.js